export const menuLinks: any[] = [
  {
    text: "Categories",
    items: [
      {
        text: "Industry Domain",
        items: [
          {
            text: "Oil & Gas",
            url: "/all-courses"
          },
          {
            text: "Energy & Utilities",
            url: "/all-courses"
          },
          {
            text: "Aerospace",
            url: "/all-courses"
          },
          {
            text: "Chemical & Pharmaceutical",
            url: "/all-courses"
          },
          {
            text: "Automotive",
            url: "/all-courses"
          },
          {
            text: "Mechanics & Turbomachinery",
            url: "/all-courses"
          },
          {
            text: "Marine",
            url: "/all-courses"
          },
          {
            text: "Rail & Transport",
            url: "/all-courses"
          },
          {
            text: "Electronics & Instrumentation",
            url: "/all-courses"
          },
          {
            text: "HVACR",
            url: "/all-courses"
          },
          {
            text: "Medical Instruments",
            url: "/all-courses"
          },
          {
            text: "Telecommunication",
            url: "/all-courses"
          },
        ],
      },
      {
        text: "Engineering Discipline",
        items: [
          {
            text: "Energy & Utilities",
            url: "/all-courses"
          },
          {
            text: "Aerospace",
            url: "/all-courses"
          },
          {
            text: "Chemical & Pharmaceutical",
            url: "/all-courses"
          },
          {
            text: "Automotive",
            url: "/all-courses"
          },
          {
            text: "Mechanics & Turbomachinery",
            url: "/all-courses"
          },
          {
            text: "Marine",
            url: "/all-courses"
          },
          {
            text: "Rail & Transport",
            url: "/all-courses"
          },
          {
            text: "Electronics & Instrumentation",
            url: "/all-courses"
          },
          {
            text: "HVACR",
            url: "/all-courses"
          },
          {
            text: "Medical Instruments",
            url: "/all-courses"
          },
        ],
      },
      {
        text: "Industry Certifications",
        items: [{
          text: "HVAC Certificaitons",
          url: "/all-courses"
        }, {
          text: "PMP",
          url: "/all-courses"
        }],
      },
    ],
  },
  {
    text: "You can earn",
    url: "/"
  },
  {
    text: "Grow your business",
    url: "/"
  },
  {
    text: "Help",
    url: "/"
  },
];
